import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-[#f5f1ea] text-[#2b2620] font-body">
      <Header />
      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#6b5f52] hover:text-[#2b2620] mb-8" data-testid="legal-back">
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-[#2b2620] mb-8">{title}</h1>
          <article className="prose max-w-none space-y-5 text-[#4a3f36] leading-relaxed [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:text-[#2b2620] [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-heading [&_h3]:text-lg [&_h3]:text-[#2b2620] [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-[#4a4b54] [&_strong]:text-[#2b2620] [&_a]:text-[#2b2620] [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:text-[#4a4b54] [&_ul>li]:my-1">
            {children}
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}
